import React from "react";

import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

export default function EmergencyPlanCustomSection({ section, sectionNumber = 3 }) {
  const data = section && section.data ? section.data : {};
  const sectionName = section && section.display_name ? section.display_name : "Custom Section";
  const content = data.content && typeof data.content.html === "string"
    ? data.content.html.trim()
    : "";

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview}`} style={{ background: "#e9c84a", color: "#1f1031" }}>
          {sectionNumber}
        </span>
        {sectionName}
      </div>
      <div className={styles.PreviewSectionBody}>
        {content ? (
          <div className={`${styles.PreviewRichText} preview-swms-v3-rich-text`} dangerouslySetInnerHTML={{ __html: content }} />
        ) : (
          <div className={styles.PreviewPadding}>No custom content available.</div>
        )}
      </div>
    </div>
  );
}
